import { Results as ReactifyResults, useResults } from "@usereactify/search";
import React, { useEffect, useRef } from "react";

import { FilterSortDrawer } from "@app/scripts/reactify/filters/FilterSortDrawer";
import { ResultCardProduct } from "@app/scripts/reactify/results/ResultCardProduct";
import { PaginationLoadMore } from "@app/scripts/reactify/pagination/LoadMore";
import { LocaleProvider } from "@app/scripts/react-providers/locales";
import { ResultCardCallout } from "@app/scripts/reactify/results/ResultCardCallout";

const PAGE_SIZE = 28;

export const Results: React.FC = () => {
  const { resultStats } = useResults();
  const containerRef = useRef(null);

  useEffect(() => {
    // update top banner item count
    if (isNaN(resultStats?.numberOfResults)) return;
    const itemCounts = document.querySelectorAll("[data-itemcount]");
    const collectionTitle = document.querySelector(".collection-hero__title");
    if (!itemCounts.length && collectionTitle) {
      collectionTitle.classList.add("hidden-no-results");
    } else {
      itemCounts?.forEach((itemCount) => (itemCount.innerHTML = (resultStats?.numberOfResults || 0).toString()));
    }
  }, [resultStats?.numberOfResults]);

  return (
    <LocaleProvider>
      <FilterSortDrawer
        className={resultStats?.numberOfResults && resultStats.numberOfResults <= 4 ? "single-row" : ""}
      />
      <div ref={containerRef} className="main-collection-product-grid">
        <ReactifyResults
          pageSize={PAGE_SIZE}
          listStyle={{}}
          listClassName="main-collection-product-grid__products"
          includeFields={[
            "callout",
            "storefrontId",
            "presentment_price_ranges",
            "images",
            "discount_amount",
            "tags",
            "price_min",
            "price_max",
            "variants.*",
          ]}
          excludeFields={["image"]}
          renderResultCardProduct={ResultCardProduct}
          renderResultCardCallout={ResultCardCallout}
          renderPaginationLoadMore={(props) => <PaginationLoadMore {...props} pageSize={PAGE_SIZE} />}
          renderNoResults={NoResults}
          renderLoading={() => (
            <div className="rs_loading">
              <h2>Loading...</h2>
            </div>
          )}
        />
      </div>
    </LocaleProvider>
  );
};

const NoResults = () => {
  useEffect(() => {
    document.body.classList.add("no-search-results");
    return () => {
      document.body.classList.remove("no-search-results");
    };
  }, []);
  return null;
};
